import { useToast } from '@hover/blueprint';

import { copyLinkViaBrowserAPI } from 'src/shared/helpers/clipboard';
import { urlWithImageShare } from 'src/shared/helpers/routing';
import {
  TranslationNamespace,
  useLocation,
  useTranslate,
} from 'src/shared/hooks';
import { Route as Routes } from 'src/shared/route';

export const useShareToast = () =>
  useToast({ position: 'top-right', duration: 2500 });

export const useCopyShareHandler = () => {
  const { href } = useLocation();
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);
  const toast = useShareToast();

  return async ({
    generatedImagePath,
    originalImagePath,
    projectShareId,
  }: {
    generatedImagePath?: string;
    originalImagePath?: string;
    projectShareId?: string | number;
  }) => {
    const baseUrl = new URL(Routes.HOMEOWNER_APP_SHARE.path, href);
    let shareUrl;
    if (projectShareId) {
      shareUrl = `${baseUrl.href}/${projectShareId}`;
    } else {
      shareUrl = urlWithImageShare(
        baseUrl.href,
        generatedImagePath,
        originalImagePath,
      );
    }

    try {
      await copyLinkViaBrowserAPI(shareUrl);
      toast({
        description: t('share.messages.copyLink.success'),
        status: 'success',
      });
    } catch (e) {
      toast({
        description: t('share.messages.copyLink.fail'),
        status: 'error',
      });
    }
  };
};
